import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoArrowBack, IoChevronDown } from "react-icons/io5";
import { fetchPublicCount } from "../../redux/ApiSlice/WaitlistCountSlice";

const EarlyCommunity = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { count, loading } = useSelector((state) => state.waitlistCount);

    useEffect(() => {
        dispatch(fetchPublicCount());
    }, [dispatch]);

    const communityImages = [
        "https://images.unsplash.com/photo-1631048905843-88f82fba8fd4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29vbCUyMGltYWdlc3xlbnwwfDF8MHx8fDA%3D",
        "https://images.unsplash.com/photo-1551491603-7d38b9e605f5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c3dpbW1pbmclMjBwb29sfGVufDB8MXwwfHx8MA%3D%3D",
        "https://plus.unsplash.com/premium_photo-1664371675057-83f34f7596a2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGN1dGUlMjBjYXR8ZW58MHwxfDB8fHww",
        "https://plus.unsplash.com/premium_photo-1730679856810-4c3a197ecad2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGNvb2wlMjBpbWFnZXN8ZW58MHwxfDB8fHww",
    ];

    return (
        <section className="flex flex-col h-full w-full overflow-y-auto p-10 no-scrollbar">
            {/* Back arrow — mobile only */}
            <button
                onClick={() => navigate(-1)}
                className="flex md:hidden items-center gap-1.5 mb-4"
            >
                <IoArrowBack className="text-[22px]" />
            </button>

            <button className="w-fit mt-2 rounded-[10px] border-2 border-[#8bcfe9] px-5 py-2.5 text-[15px] font-semibold text-[#139AC3]">
                Be part of the early community
            </button>

            <h1 className="mt-8 max-w-[580px] text-[2.5rem] font-sans font-black leading-[1.05] tracking-[-0.02em] text-[#1f2328] sm:text-[3.25rem]">
                <span className="text-[#139AC3]">
                    {loading ? "..." : count !== null ? `${count}+` : "300+"}
                </span>{" "}
                people on the
                <br />
                waitlist
            </h1>

            <p className="mt-8 text-[14px] font-semibold text-[#5f656c] sm:text-[15px]">
                Join people ready for something better.
            </p>

            <div className="mt-12 flex flex-wrap gap-5">
                {communityImages.map((data, index) => (
                    <img
                        key={index}
                        src={data}
                        alt={`Community ${index + 1}`}
                        className="h-80 w-full md:h-80 md:w-52 rounded-[24px] object-cover"
                    />
                ))}
            </div>

            <div className="w-full flex items-center justify-center absolute bottom-5">
                <button
                    onClick={() => navigate("/about-us/our-team")}
                    className="flex items-center gap-1.5 text-[14px] font-semibold text-[#2E9DDA] hover:underline mr-20"
                >
                    Our team
                    <IoChevronDown className="text-[15px]" />
                </button>
            </div>
        </section>
    );
};

export default EarlyCommunity